import { FuseAnimate } from '@fuse';
import _ from '@lodash';
import { Table, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import ImprimirApp from 'app/Core/Components/Imprimir/ImprimirApp';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/EmpresaPessoaOrcamentoActions';

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    noBorder: {
        borderBottom: '0px'
    },
    anotherLine: {
        backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#D4D4D4'
    }
});


class EmpresaPessoaOrcamentoList extends XAPPComponent {

    state = {
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.EmpresaPessoaOrcamento.error) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaOrcamento.error,
                variant: 'error'
            });
            this.props.EmpresaPessoaOrcamento.error = null;
        }
    }

    getColumnsItens = () => {
        return [
            {
                Header: "ID",
                accessor: "id",
                align: "center"
            },
            {
                Header: "Nome",
                accessor: "nome",
                align: "center"
            },
            {
                Header: "Quantidade",
                accessor: "quantidade",
                align: "center"
            },
            {
                Header: "Unidade med.",
                accessor: "unidademedida",
                align: "center"
            },
            {
                Header: "Valor",
                accessor: "valordescricao",
                align: "center"
            },
            {
                Header: "Valor total",
                accessor: "valortotaldescricao",
                align: "center"
            }
        ];
    }

    getColumns = () => {
        return [
            {
                Header: "ID",
                accessor: "idpessoaformulario",
                align: "center"
            },
            {
                Header: "Nome",
                accessor: "nome",
                align: "center"
            },
            // {
            //     Header: "Valor",
            //     accessor: "valortotaldescricao",
            //     align: "center"
            // },
            {
                Header: "Data",
                accessor: "datainsdescricao",
                align: "center"
            },
            {
                Header: "Validade",
                accessor: "validadedescricao",
                align: "center"
            },
            {
                Header: "Gerar pedido",
                accessor: "icon_gerarpedido",
                align: "center"
            },
            {
                Header: "Imprimir",
                accessor: "icon_imprimir_orcamento",
                align: "center"
            }
        ];
    }

    getIconCell = (_AColumn, _AValue) => {
        if (_AValue.statusregistro === 0) {
            return (
                <XAPPButton
                    type="Icon"
                    className="h-32 w-32 p-6"
                    variant="contained"
                    color="primary"
                    onClick={() => { }}
                    iconProps={"justify-center text-red"}
                    icon={"close"}
                />
            )
        }
        else {
            switch (_AColumn.accessor) {
                case "icon_gerarpedido":
                    return (
                        <React.Fragment>
                            {(_.isUndefined(_AValue.idpedido) || _.isNull(_AValue.idpedido)) ?
                                <XAPPButton
                                    type="Icon"
                                    className="h-32 w-32 p-6"
                                    variant="contained"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        this.props.gerarPedido(_AValue);
                                    }}
                                    iconProps={"justify-center text-yellow"}
                                    icon={"request"}
                                />
                                :
                                <XAPPButton
                                    type="Icon"
                                    className="h-32 w-32 p-6"
                                    variant="contained"
                                    onClick={(event) => { }}
                                    iconProps={"justify-center text-green"}
                                    icon={"done"}
                                />
                            }
                        </React.Fragment>
                    )
                case "icon_imprimir_orcamento":
                    return (
                        <ImprimirApp
                            data={JSON.stringify(_AValue.formulario)}
                            xappRouteParams={this.props.xappRouteParams}
                            key="btnImprimir"
                            id={"imprimirpessoaformulario"}
                            label={""}
                            idrelatorio={this.props.tipo}
                            type="Icon"
                            className="text-blue"
                        // column={this.getColumns(ARelatorio.campos)}
                        />
                    )
                default:
                    return (
                        <div />
                    )
            }
        }
    }

    render() {
        const { tabValue, EmpresaPessoaOrcamento, get, openEditDialog, classes } = this.props;

        var bgColor = 0;
        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <Table className="min-w-full" aria-labelledby="tableTitle">
                        <TableHead>
                            <TableRow className="h-64">
                                {this.getColumns().map(column => (
                                    <TableCell
                                        key={column.accessor}
                                        align={'center'}
                                        style={{ padding: '2px 12px 2px 12px' }}
                                    >
                                        {column.Header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!_.isNull(EmpresaPessoaOrcamento.data) && EmpresaPessoaOrcamento.data.map(n => {
                                bgColor = bgColor === 0 ? 1 : 0;
                                return (
                                    <React.Fragment>
                                        <TableRow className={classNames(n.statusregistro === 1 && "cursor-pointer", bgColor === 1 && classes.anotherLine)} >
                                            {this.getColumns().map(column => (
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                    align={column.align}
                                                    style={{ padding: '2px 12px 2px 12px' }}
                                                    onClick={() => { !column.accessor.includes("icon_") && n.statusregistro === 1 && openEditDialog(n) }}
                                                >
                                                    {column.accessor.includes("icon_") ? (
                                                        !_.isUndefined(n.itens) && !_.isNull(n.itens) && n.itens.length > 0 &&
                                                        this.getIconCell(column, n)
                                                    ) : (
                                                        n[column.accessor]
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                        {!_.isUndefined(n.itens) && !_.isNull(n.itens) && n.itens.length > 0 &&
                                            <TableRow className={classNames("h-32", bgColor === 1 && classes.anotherLine)}>
                                                <TableCell colSpan={this.getColumns().length}>
                                                    <Table className={"min-w-full"} aria-labelledby="tableTitle">
                                                        <TableHead>
                                                            <TableRow className="h-32">
                                                                {this.getColumnsItens().map(column => (
                                                                    <TableCell
                                                                        key={column.accessor}
                                                                        align={'center'}
                                                                        style={{ padding: '2px 12px 2px 12px' }}
                                                                    >
                                                                        {column.Header}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {n.itens.map(m => (
                                                                <TableRow className="h-32">
                                                                    {this.getColumnsItens().map(column => (
                                                                        <TableCell className={classes.noBorder} component="th" scope="row" align={column.align} style={{ padding: '2px 12px 2px 12px' }}>
                                                                            {m[column.accessor]}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                            </TableRow>
                                        }
                                    </React.Fragment>
                                )
                            })}
                        </TableBody>
                    </Table>
                </FuseAnimate>
            </React.Fragment>
        )
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openEditDialog: Actions.openEditDialog,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ EmpresaPessoaOrcamento }) {
    return {
        EmpresaPessoaOrcamento: EmpresaPessoaOrcamento,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaOrcamentoList)));
